import { INotificationMessage, tVariants } from "@fl/shared/src/types/messages";
import { v4 as uuidv4 } from "uuid";

export const generateMessageReturn = (
  header: string,
  message: string,
  variant: tVariants
): INotificationMessage => {
  return {
    date: new Date(),
    header,
    message,
    variant,
    show: true,
    key: uuidv4().toString(),
  };
};
